(()=>{if(window.DefiFourteen){window.DefiFourteen.mount(document);return}const active=new WeakMap();function init(root){if(active.has(root))return;const ac=new AbortController(),dispose=[],on=(target,event,fn,opts={})=>target.addEventListener(event,fn,{...opts,signal:ac.signal});const sources=JSON.parse(root.dataset.storySources),source=name=>sources[name];
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* flowing gradient behind the final CTA — hand-written shader, no library */
  var cv=root.querySelector('[data-ref=ctaShader]');
  if(!cv) return;
  var gl=null;
  try{ gl=cv.getContext('webgl',{antialias:false,alpha:true,premultipliedAlpha:false}); }catch(e){}
  if(!gl) return; /* falls back to the CSS gradient underneath */

  var vs='attribute vec2 p;void main(){gl_Position=vec4(p,0.,1.);}';
  var fs=[
  'precision mediump float;',
  'uniform vec2 r;uniform float t;',
  'float h(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}',
  'float n(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);',
  ' return mix(mix(h(i),h(i+vec2(1,0)),f.x),mix(h(i+vec2(0,1)),h(i+vec2(1,1)),f.x),f.y);}',
  'float fbm(vec2 p){float v=0.,a=.5;for(int i=0;i<5;i++){v+=a*n(p);p*=2.02;a*=.5;}return v;}',
  'void main(){',
  ' vec2 uv=gl_FragCoord.xy/r;',
  ' vec2 q=vec2(fbm(uv*2.2+t*.045),fbm(uv*2.2+vec2(3.4,1.7)-t*.035));',
  ' float f=fbm(uv*2.6+q*1.6+vec2(t*.02,-t*.025));',
  /* brand blues only — no purple */
  ' vec3 c1=vec3(0.075,0.290,0.980);',
  ' vec3 c2=vec3(0.345,0.560,1.000);',
  ' vec3 c3=vec3(0.043,0.157,0.620);',
  ' vec3 col=mix(c3,c1,smoothstep(0.25,0.72,f));',
  ' col=mix(col,c2,smoothstep(0.55,0.98,f+q.x*0.35));',
  ' col+=0.05*smoothstep(0.8,1.0,f);',
  ' gl_FragColor=vec4(col,1.0);',
  '}'].join('\n');

  function sh(type,src){var o=gl.createShader(type);gl.shaderSource(o,src);gl.compileShader(o);
    if(!gl.getShaderParameter(o,gl.COMPILE_STATUS)){return null;} return o;}
  var v=sh(gl.VERTEX_SHADER,vs), f2=sh(gl.FRAGMENT_SHADER,fs);
  if(!v||!f2) return;
  var pr=gl.createProgram();gl.attachShader(pr,v);gl.attachShader(pr,f2);gl.linkProgram(pr);
  if(!gl.getProgramParameter(pr,gl.LINK_STATUS)) return;
  gl.useProgram(pr);
  var buf=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,buf);
  gl.bufferData(gl.ARRAY_BUFFER,new Float32Array([-1,-1,3,-1,-1,3]),gl.STATIC_DRAW);
  var loc=gl.getAttribLocation(pr,'p');gl.enableVertexAttribArray(loc);gl.vertexAttribPointer(loc,2,gl.FLOAT,false,0,0);
  var uR=gl.getUniformLocation(pr,'r'), uT=gl.getUniformLocation(pr,'t');

  function size(){
    var d=Math.min(window.devicePixelRatio||1,1.5);
    var w=Math.max(1,Math.round(cv.clientWidth*d)), hgt=Math.max(1,Math.round(cv.clientHeight*d));
    if(cv.width!==w||cv.height!==hgt){cv.width=w;cv.height=hgt;gl.viewport(0,0,w,hgt);}
    gl.uniform2f(uR,cv.width,cv.height);
  }
  function frame(time){
    size(); gl.uniform1f(uT,time*0.001); gl.drawArrays(gl.TRIANGLES,0,3);
  }
  dispose.push(()=>{run=false;cancelAnimationFrame(raf);gl.deleteBuffer(buf);gl.deleteProgram(pr);gl.deleteShader(v);gl.deleteShader(f2)});frame(0); cv.classList.add('ready');
  if(reduce) return;

  var run=false,raf=0,inView=false;
  function updateRun(){var next=inView&&!document.hidden;if(next===run)return;run=next;if(run)raf=requestAnimationFrame(loop);else cancelAnimationFrame(raf);}
  function loop(ts){ if(!run) return; frame(ts); raf=requestAnimationFrame(loop); }
  if('IntersectionObserver' in window){
    var observer=new IntersectionObserver(function(es){
      es.forEach(function(e){
        inView=e.isIntersecting;updateRun();
      });
    },{rootMargin:'150px'});observer.observe(cv);dispose.push(()=>observer.disconnect());
  } else { inView=true; updateRun(); }
  on(document,'visibilitychange',function(){
    updateRun();
  });
  on(window,'resize',function(){ if(!run) frame(performance.now()); });
})();

active.set(root,()=>{ac.abort();dispose.forEach(fn=>fn());active.delete(root)})}function roots(scope){return [...(scope.matches?.('[data-defi-fourteen]')?[scope]:[]),...scope.querySelectorAll('[data-defi-fourteen]')]}function mount(scope){roots(scope).forEach(init)}window.DefiFourteen={mount};mount(document);document.addEventListener('shopify:section:load',e=>mount(e.target));document.addEventListener('shopify:section:unload',e=>roots(e.target).forEach(r=>active.get(r)?.()))})();
